import { ExploreType, routes } from "@/common/utils/routes";

export enum TABS_URLS {
  home = "/",
  explore = "/explore",
  add = "/create",
  profile = "/profile",
  categories = "/categories",
  niches = "/niches",
}

export enum TABS_LABELS {
  home = "Home",
  explore = "Explore",
  add = "Upload",
  profile = "Profile",
  categories = "Categories",
  niches = "Niches",
  studio = "Studio",
}

const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const matchesBasePath = (path: string, base: string) => {
  const cleanBase = base.split("?")[0];
  const re = new RegExp(`^${escapeRegExp(cleanBase)}(?:$|[/?])`);
  return re.test(path);
};

export const getTabStatus = (
  path: string,
  username: string | null,
): { [key: string]: boolean | null | string } => ({
  [TABS_URLS.home]: path === routes.home(),
  [TABS_URLS.explore]: [
    routes.explore(ExploreType.gifs),
    routes.explore(ExploreType.images),
    routes.explore(ExploreType.creators),
    routes.explore(ExploreType.niches),
  ].includes(path),
  [TABS_URLS.add]: path === routes.create(),
  [TABS_URLS.categories]: path.includes(routes.trendingTags()),
  [TABS_URLS.profile]: username && path === routes.user(username),
  [TABS_URLS.niches]: matchesBasePath(path, routes.niches()),
});
